// Webpack Imports
import * as bootstrap from 'bootstrap';
import Chart from 'chart.js/auto'
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Thumbs, FreeMode, EffectCards} from 'swiper/modules';
import {isFunction} from "chart.js/helpers";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Legend} from 'chart.js';

(function () {
    'use strict';

    function message_alert(type, text) {
        const toast = document.getElementById('alert-toast')
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toast)
        toast.getElementsByClassName('toast-body')[0].innerHTML = text
        toast.classList.remove('text-bg-success')
        toast.classList.remove('text-bg-danger')
        switch (type) {
            case('success'): {
                toast.classList.add('text-bg-success')
                break;
            }
            case('error'): {
                toast.classList.add('text-bg-danger')
                break;
            }
        }
        toastBootstrap.show()
    }
    const swiper = new Swiper('.challenge-slider', {
        // configure Swiper to use modules
        //modules: [Navigation, Pagination],
        modules: [Navigation, Pagination, Autoplay, EffectCards],
        autoplay: false,
        //slidesPerView: 1,
        loop: false,
        //effect: "cards",
        grabCursor: true,
        direction: "vertical",
        //autoHeight:false,
        //loop: true,
        //centeredSlides: true,
        //initialSlide: 0,
        slideToClickedSlide: true,
        effect: "cards",
        cardsEffect: {
            rotate: false,
            perSlideOffset: 12,
            slideShadows: false,
        },
    });

    const otherSwiper = new Swiper('.other-challenge-slider', {
        // configure Swiper to use modules
        //modules: [Navigation, Pagination],
        modules: [Navigation, Pagination, Autoplay, EffectCards],
        autoplay: false,
        slidesPerView: 1.25,
        spaceBetween: 20,
        //loop: true,
        //effect: "cards",
        grabCursor: true,
        //direction: "vertical",
        //autoHeight:false,
        //loop: true,
        //centeredSlides: true,
        slideToClickedSlide: true,
    });
    var profileForm=document.getElementById('profile-form');
    if(profileForm){
        const ProfileModal = new bootstrap.Modal('#profileModal', {
            keyboard: false
        })
        let profileName=document.getElementById('profile-name')
        let profileMobile=document.getElementById('profile-mobile')
        let profileBirthday=document.getElementById('profile-birthday')
        let profileDiet=document.getElementById('profile-diet')
        let profileGender=document.getElementsByName("genderInput");
        let profileNonce=document.getElementById("profile_nonce");
        let profileButton=document.getElementById("profile-update-btn");
        let gender='';
        profileForm.addEventListener('submit',function (e) {
            e.preventDefault()

            for (let i = 0; i < profileGender.length; i++) {
                if (profileGender[i].checked)
                    gender=profileGender[i].value;
            }
            let formData = new URLSearchParams({
                action: 'profile_update',
                name: profileName.value,
                gender:gender,
                birthday:profileBirthday.value,
                diet:profileDiet.value,
                nonce:profileNonce.value
            });
            profileButton.disabled = true;
            message_alert('success', 'در حال به روزرسانی...');
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        ProfileModal.hide();
                        profileButton.disabled = false;
                        message_alert('success', data.data.message);
                    } else {
                        message_alert('error', data.data.message);
                    }
                })
                .catch(error => {
                    message_alert('error', 'مشکلی پیش آمده لطفا دقایقی بعد امتحان کنید.');
                });
        })
    }

    var chartElementRunning = document.getElementById('user-running-stats');
    var chartElementMeditation = document.getElementById('user-meditation-stats');
    var chartElementMeal = document.getElementById('user-meal-stats');
    if (chartElementRunning) {
        Chart.register(ChartDataLabels);
        Chart.register(Legend);
        var runningDataHistory = [];
        var statChart = new Chart(chartElementRunning,
            {
                type: 'bar',
                data: {
                    labels: runningDataHistory.map(row => row.date),
                    datasets: [
                        {
                            //label: 'Acquisitions by year',
                            data: runningDataHistory.map(row => row.value),
                            backgroundColor: (context) => {
                                // Change color for last bar only
                                return context.dataIndex === 6 ? '#70B636' : '#88A895';
                            },
                            //borderColor: '#88A895',

                        }

                    ]
                },
                options: {
                    scales: {
                        x: {
                            grid: {
                                display: false,
                                drawBorder: false // removes x-axis line
                            },
                            ticks: {
                                display: true, // keeps the labels
                                maxRotation: 60,
                                minRotation: 60,
                                color: '#E0EFE6',
                                font: {
                                    family: 'pelak',
                                }
                            }
                        },
                        y: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                display: false // hides y-axis labels
                            },
                            border: {
                                display: false // removes y-axis line
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            color: '#ffffff', // White color
                            font: {
                                family: 'pelak',
                                weight: 'bold',
                                size: 11
                            },
                            //rotation: -90, // Rotate 90 degrees counter-clockwise (use 90 for clockwise)
                            anchor: 'center', // Position at center of bar
                            align: 'center', // Center alignment
                            textAlign: 'center',
                            formatter: (value) => value,
                            padding: {
                                //top: 20 // Adjust this if labels appear cut off
                            }
                        },
                        legend: {
                            display: false // optional: hide legend
                        }
                    },
                    elements: {
                        bar: {
                            borderRadius: 6 // This will apply to all corners
                        }
                    }
                },

            }
        );
        document.addEventListener('DOMContentLoaded', function () {

            const loadDataHistory = new URLSearchParams({
                action: 'get_running_history',
            })
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: loadDataHistory
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
                .then(data => {
                    if (data.success) {

                        runningDataHistory = data.data.data
                        statChart.data.labels = data.data.data.map(row => row.date);
                        statChart.data.datasets[0].data = data.data.data.map(row => row.value.toFixed(1));
                        statChart.update();
                        document.getElementsByClassName('today-value')[0].innerHTML = runningDataHistory[runningDataHistory.length - 1].value;
                    } else {
                        console.log(data)
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        })

        const runningModal = new bootstrap.Modal('#runningModal', {
            keyboard: false
        })
        document.getElementById('add-node').addEventListener('click', function (e) {
            //var runningModal=document.getElementById('runningModal');

            runningModal.show();

            // ایجاد داده جدید
            // const newYear = 1999;
            // const newCount = 11;
            //
            // // اضافه کردن به آرایه داده اصلی
            // data.push({ year: newYear, count: newCount });
            //
            // // بروزرسانی چارت با داده‌های جدید
            // statChart.data.labels = data.map(row => row.year);
            // statChart.data.datasets[0].data = data.map(row => row.count);
            // statChart.update();
        });
        document.querySelectorAll('.kilometer-selector').forEach(item => {

            item.addEventListener('click', function () {
                document.querySelectorAll('.kilometer-selector').forEach(i => {
                    i.classList.remove('selected');
                });
                this.classList.add('selected')
                document.getElementById('select-kilometer').value = this.dataset.value
                document.getElementById('round-to-kilometer').innerHTML = this.dataset.value
            })
        })
        document.getElementById('addRunningValue').addEventListener('click', function (e) {
            let run_date = document.getElementById('running-date').value;
            let run_kil = document.getElementById('select-kilometer').value;
            let run_is_enq = document.getElementById('isEnqelab').value;
            let runningData = new URLSearchParams({
                action: 'calculate_running',
                run_date: run_date,
                run_kil: run_kil,
                run_is_enq: run_is_enq,
            });
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: runningData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {

                    if (data.success) {
                        runningModal.hide();
                        let allUsersValue = document.querySelector('.all-users-value');
                        let currentUserValue = document.querySelector('.current-user-value');
                        let allUserValue = document.querySelector('.all-user-value');
                        let todayValue = document.querySelector('.today-value');
                        allUsersValue.innerHTML = data.data.total_users_running[0].total
                        currentUserValue.innerHTML = data.data.total.toFixed(1)
                        allUserValue.innerHTML = data.data.total.toFixed(1)
                        todayValue.innerHTML = data.data.today
                        //ایجاد داده جدید
                        //const newDate = data.data.run_date;
                        // newValue = parseFloat(data.data.run_kil);
                        // اضافه کردن به آرایه داده اصلی
                        //runningDataHistory.push({date: newDate, value: newValue});
                        runningDataHistory = data.data.data;
                        // بروزرسانی چارت با داده‌های جدید

                        statChart.data.labels = runningDataHistory.map(row => row.date);
                        statChart.data.datasets[0].data = runningDataHistory.map(row => row.value.toFixed(1));
                        statChart.update();
                        message_alert('success', 'با موفقیت ثبت شد.')
                    } else {
                        message_alert('error', data.data.error);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        })
        const isEnqelabCollapse = new bootstrap.Collapse('#isEnqelabCollapse', {
            toggle: false
        })

        // triggerFirstTabEl = document.querySelector('#isEnqelabCollapse li:first-child button')
        //const triggerLastTabEl = document.querySelector('#isEnqelabCollapse li:last-child button')
        document.getElementById('isEnqelab').addEventListener('change', function (e) {
            isEnqelabCollapse.toggle()
            // if(e.target.checked){
            //     bootstrap.Tab.getInstance(triggerFirstTabEl).show() // Select tab by name
            // }
            // else {
            //     bootstrap.Tab.getInstance(triggerLastTabEl).show() // Select tab by name
            // }
        })
    }
    if (chartElementMeditation) {
        Chart.register(ChartDataLabels);
        Chart.register(Legend);
        var meditationDataHistory = [];
        var meditationStatChart = new Chart(chartElementMeditation,
            {
                type: 'bar',
                data: {
                    labels: meditationDataHistory.map(row => row.date),
                    datasets: [
                        {
                            //label: 'Acquisitions by year',
                            data: meditationDataHistory.map(row => row.value),
                            backgroundColor: (context) => {
                                // Change color for last bar only
                                return context.dataIndex === 6 ? '#70B636' : '#88A895';
                            },
                            //borderColor: '#88A895',

                        }

                    ]
                },
                options: {
                    scales: {
                        x: {
                            grid: {
                                display: false,
                                drawBorder: false // removes x-axis line
                            },
                            ticks: {
                                display: true, // keeps the labels
                                maxRotation: 60,
                                minRotation: 60,
                                color: '#E0EFE6',
                                font: {
                                    family: 'pelak',
                                }
                            }
                        },
                        y: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                display: false // hides y-axis labels
                            },
                            border: {
                                display: false // removes y-axis line
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            color: '#ffffff', // White color
                            font: {
                                family: 'pelak',
                                weight: 'bold',
                                size: 11
                            },
                            //rotation: -90, // Rotate 90 degrees counter-clockwise (use 90 for clockwise)
                            anchor: 'center', // Position at center of bar
                            align: 'center', // Center alignment
                            textAlign: 'center',
                            formatter: (value) => value,
                            padding: {
                                //top: 20 // Adjust this if labels appear cut off
                            }
                        },
                        legend: {
                            display: false // optional: hide legend
                        }
                    },
                    elements: {
                        bar: {
                            borderRadius: 6 // This will apply to all corners
                        }
                    }
                },

            }
        );
        document.addEventListener('DOMContentLoaded', function () {

            const loadDataHistory = new URLSearchParams({
                action: 'get_meditation_history',
            })
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: loadDataHistory
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
                .then(data => {
                    if (data.success) {

                        meditationDataHistory = data.data.data
                        meditationStatChart.data.labels = data.data.data.map(row => row.date);
                        meditationStatChart.data.datasets[0].data = data.data.data.map(row => parseInt(row.value));
                        meditationStatChart.update();
                        document.getElementsByClassName('today-value')[0].innerHTML = meditationDataHistory[meditationDataHistory.length - 1].value;
                    } else {
                        console.log(data)
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        })

        const meditationModal = new bootstrap.Modal('#meditationModal', {
            keyboard: false
        })
        document.getElementById('add-node').addEventListener('click', function (e) {
            //var runningModal=document.getElementById('runningModal');

            meditationModal.show();

            // ایجاد داده جدید
            // const newYear = 1999;
            // const newCount = 11;
            //
            // // اضافه کردن به آرایه داده اصلی
            // data.push({ year: newYear, count: newCount });
            //
            // // بروزرسانی چارت با داده‌های جدید
            // statChart.data.labels = data.map(row => row.year);
            // statChart.data.datasets[0].data = data.map(row => row.count);
            // statChart.update();
        });
        document.querySelectorAll('.meditation-selector').forEach(item => {

            item.addEventListener('click', function () {
                document.querySelectorAll('.meditation-selector').forEach(i => {
                    i.classList.remove('selected');
                });
                this.classList.add('selected')
                document.getElementById('select-meditation').value = this.dataset.value
            })
        })
        document.getElementById('addMeditationValue').addEventListener('click', function (e) {
            let med_date = document.getElementById('meditation-date').value;
            let med_min = document.getElementById('select-meditation').value;
            let meditationData = new URLSearchParams({
                action: 'calculate_meditation',
                med_date: med_date,
                med_min: med_min,
            });
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: meditationData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {

                    if (data.success) {
                        meditationModal.hide();
                        let allUsersValue = document.querySelector('.all-users-value');
                        let currentUserValue = document.querySelector('.current-user-value');
                        let allUserValue = document.querySelector('.all-user-value');
                        let todayValue = document.querySelector('.today-value');
                        allUsersValue.innerHTML = data.data.total_users_meditation[0].total
                        currentUserValue.innerHTML = data.data.total
                        allUserValue.innerHTML = data.data.total
                        todayValue.innerHTML = data.data.today
                        //ایجاد داده جدید
                        //const newDate = data.data.run_date;
                        // newValue = parseFloat(data.data.run_kil);
                        // اضافه کردن به آرایه داده اصلی
                        //runningDataHistory.push({date: newDate, value: newValue});
                        meditationDataHistory = data.data.data;
                        // بروزرسانی چارت با داده‌های جدید

                        meditationStatChart.data.labels = meditationDataHistory.map(row => row.date);
                        meditationStatChart.data.datasets[0].data = meditationDataHistory.map(row => parseInt(row.value));
                        meditationStatChart.update();
                        message_alert('success', 'با موفقیت ثبت شد.')
                    } else {
                        message_alert('error', data.data.error);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        })
    }
    if (chartElementMeal) {
        Chart.register(ChartDataLabels);
        Chart.register(Legend);
        var mealDataHistory = [];
        var mealStatChart = new Chart(chartElementMeal,
            {
                type: 'bar',
                data: {
                    labels: mealDataHistory.map(row => row.date),
                    datasets: [
                        {
                            //label: 'Acquisitions by year',
                            data: mealDataHistory.map(row => row.value),
                            backgroundColor: (context) => {
                                // Change color for last bar only
                                return context.dataIndex === 6 ? '#70B636' : '#88A895';
                            },
                            //borderColor: '#88A895',

                        }

                    ]
                },
                options: {
                    scales: {
                        x: {
                            grid: {
                                display: false,
                                drawBorder: false // removes x-axis line
                            },
                            ticks: {
                                display: true, // keeps the labels
                                maxRotation: 60,
                                minRotation: 60,
                                color: '#E0EFE6',
                                font: {
                                    family: 'pelak',
                                }
                            }
                        },
                        y: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                display: false // hides y-axis labels
                            },
                            border: {
                                display: false // removes y-axis line
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            color: '#ffffff', // White color
                            font: {
                                family: 'pelak',
                                weight: 'bold',
                                size: 11
                            },
                            //rotation: -90, // Rotate 90 degrees counter-clockwise (use 90 for clockwise)
                            anchor: 'center', // Position at center of bar
                            align: 'center', // Center alignment
                            textAlign: 'center',
                            formatter: (value) => value,
                            padding: {
                                //top: 20 // Adjust this if labels appear cut off
                            }
                        },
                        legend: {
                            display: false // optional: hide legend
                        }
                    },
                    elements: {
                        bar: {
                            borderRadius: 6 // This will apply to all corners
                        }
                    }
                },

            }
        );
        document.addEventListener('DOMContentLoaded', function () {

            const loadDataHistory = new URLSearchParams({
                action: 'get_meal_history',
            })
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: loadDataHistory
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
                .then(data => {
                    if (data.success) {

                        mealDataHistory = data.data.data
                        mealStatChart.data.labels = data.data.data.map(row => row.date);
                        mealStatChart.data.datasets[0].data = data.data.data.map(row => parseInt(row.value));
                        mealStatChart.update();
                        document.getElementsByClassName('today-value')[0].innerHTML = mealDataHistory[mealDataHistory.length - 1].value;
                    } else {
                        console.log(data)
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        })

        const mealModal = new bootstrap.Modal('#mealModal', {
            keyboard: false
        })
        document.getElementById('add-node').addEventListener('click', function (e) {
            //var runningModal=document.getElementById('runningModal');

            mealModal.show();

            // ایجاد داده جدید
            // const newYear = 1999;
            // const newCount = 11;
            //
            // // اضافه کردن به آرایه داده اصلی
            // data.push({ year: newYear, count: newCount });
            //
            // // بروزرسانی چارت با داده‌های جدید
            // statChart.data.labels = data.map(row => row.year);
            // statChart.data.datasets[0].data = data.map(row => row.count);
            // statChart.update();
        });
        document.querySelectorAll('.meal-selector').forEach(item => {

            item.addEventListener('click', function () {
                document.querySelectorAll('.meal-selector').forEach(i => {
                    i.classList.remove('selected');
                });
                this.classList.add('selected')
                document.getElementById('select-meal').value = this.dataset.value
            })
        })
        document.getElementById('addMealValue').addEventListener('click', function (e) {
            let meal_date = document.getElementById('meal-date').value;
            let meal_min = document.getElementById('select-meal').value;
            let mealData = new URLSearchParams({
                action: 'calculate_meal',
                meal_date: meal_date,
                meal_min: meal_min,
            });
            fetch(phoneAuth.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: mealData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {

                    if (data.success) {
                        mealModal.hide();
                        let allUsersValue = document.querySelector('.all-users-value');
                        let currentUserValue = document.querySelector('.current-user-value');
                        let allUserValue = document.querySelector('.all-user-value');
                        let todayValue = document.querySelector('.today-value');
                        allUsersValue.innerHTML = data.data.total_users_meal[0].total
                        currentUserValue.innerHTML = data.data.total.toFixed(1)
                        allUserValue.innerHTML = data.data.total.toFixed(1)
                        todayValue.innerHTML = data.data.today
                        //ایجاد داده جدید
                        //const newDate = data.data.run_date;
                        // newValue = parseFloat(data.data.run_kil);
                        // اضافه کردن به آرایه داده اصلی
                        //runningDataHistory.push({date: newDate, value: newValue});
                        mealDataHistory = data.data.data;
                        // بروزرسانی چارت با داده‌های جدید

                        mealStatChart.data.labels = mealDataHistory.map(row => row.date);
                        mealStatChart.data.datasets[0].data = mealDataHistory.map(row => parseInt(row.value));
                        mealStatChart.update();
                        message_alert('success', 'با موفقیت ثبت شد.')
                    } else {
                        message_alert('error', data.data.error);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        })
    }
    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        let otpTimer;
        let timeLeft = 120; // 2 minutes in seconds

        // Form elements
        const authForm = document.getElementById('phone-auth-form');
        const authFormLogin = document.getElementById('phone-auth-form-login');
        const verifyForm = document.getElementById('verify-otp-form');
        const phoneInputLogin = document.getElementById('phoneInputLogin');
        const phoneInputRegister = document.getElementById('phoneInputRegister');
        const nameInput = document.getElementById('nameInput');
        const otpInput = document.getElementById('otpInput');
        const sendOtpBtnRegister = document.getElementById('send-otp-btn-register');
        const sendOtpBtnLogin = document.getElementById('send-otp-btn-login');
        const verifyOtpBtn = document.getElementById('verify-otp-btn');
        const otpGroup = document.querySelector('.otp-group');
        const otpTimerDisplay = document.getElementById('otp-timer');
        const authMessage = document.getElementById('auth-message');
        const otpResend = document.getElementById('otp-resend')
        const editPhone = document.getElementById('edit-phone')
        const phoneNeedOtp = document.getElementById('phone-need-otp')
        const loginLink = document.querySelector('.login-link')
        const registerLink = document.querySelector('.register-link')

        // Send OTP button click handler
        if (sendOtpBtnRegister) {
            sendOtpBtnRegister.addEventListener('click', function (e) {
                e.preventDefault()
                const phone = phoneInputRegister.value.trim();
                const name = nameInput.value.trim();

                if (!phone) {
                    message_alert('error', 'لطفا شماره موبایل خود را وارد کنید.');
                    return;
                }
                if (!name) {
                    message_alert('error', 'لطفا نام خود را وارد کنید.');
                    return;
                }

                // Disable button during request
                sendOtpBtnRegister.disabled = true;
                sendOtpBtnRegister.textContent = phoneAuth.sendingText;

                let formData = new URLSearchParams({
                    action: 'send_otp',
                    phone: phone,
                    name: name,
                });
                fetch(phoneAuth.ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {

                        if (data.success) {
                            message_alert('success', data.data.message);
                            if (data.data.debug_otp) {
                                console.log('DEBUG OTP: ' + data.data.debug_otp);
                            }

                            // Show OTP field and verify button
                            verifyForm.style.display = 'block';
                            verifyOtpBtn.style.display = 'block';
                            authForm.style.display = 'none';
                            authFormLogin.style.display = 'none';
                            phoneNeedOtp.innerHTML = data.data.phone
                            // Start OTP timer
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'infoForm',
                                'option': '2'
                            });

                            startOtpTimer();

                        } else {
                            message_alert('error', data.data.message);
                        }
                        sendOtpBtnRegister.disabled = false;
                        sendOtpBtnRegister.textContent = phoneAuth.resendText;
                    })
                    .catch(error => {
                        message_alert('error', 'ارسال کد انجام نشد لطفا مجدد تلاش کنید.');
                        sendOtpBtnRegister.disabled = false;
                        sendOtpBtnRegister.textContent = 'Send OTP';
                        console.error('Error:', error);
                    });
            });
            editPhone.addEventListener('click', function (e) {
                e.preventDefault()
                authForm.style.display = 'none'
                authFormLogin.style.display = 'block'
                verifyForm.style.display = 'none'
            })
            sendOtpBtnLogin.addEventListener('click', function (e) {
                e.preventDefault()
                const phone = phoneInputLogin.value.trim();

                if (!phone) {
                    message_alert('error', 'لطفا شماره موبایل خود را وارد کنید.');
                    return;
                }

                // Disable button during request
                sendOtpBtnLogin.disabled = true;
                sendOtpBtnLogin.textContent = phoneAuth.sendingText;

                let formData = new URLSearchParams({
                    action: 'send_otp',
                    phone: phone,
                });
                fetch(phoneAuth.ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {

                        if (data.success) {
                            message_alert('success', data.data.message);
                            if (data.data.debug_otp) {
                                console.log('DEBUG OTP: ' + data.data.debug_otp);
                            }

                            // Show OTP field and verify button
                            verifyForm.style.display = 'block';
                            verifyOtpBtn.style.display = 'block';
                            authForm.style.display = 'none';
                            authFormLogin.style.display = 'none';
                            phoneNeedOtp.innerHTML = data.data.phone
                            // Start OTP timer
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'infoForm',
                                'option': '2'
                            });
                            startOtpTimer();

                        } else {
                            console.log(data)
                            message_alert('error', data.data.message);
                        }
                        sendOtpBtnLogin.disabled = false;
                        sendOtpBtnLogin.textContent = phoneAuth.resendText;
                    })
                    .catch(error => {
                        message_alert('error', 'ارسال کد انجام نشد لطفا مجدد تلاش کنید.');
                        sendOtpBtnLogin.disabled = false;
                        sendOtpBtnLogin.textContent = 'ارسال کد';
                        console.error('Error:', error);
                    });
            });
            loginLink.addEventListener('click', function (e) {
                e.preventDefault();
                authForm.style.display = 'none'
                authFormLogin.style.display = 'block'
            })
            registerLink.addEventListener('click', function (e) {
                e.preventDefault();
                authForm.style.display = 'block'
                authFormLogin.style.display = 'none'
            })
        }

        // Form submission handler
        if (verifyForm) {
            verifyForm.addEventListener('submit', function (e) {
                e.preventDefault();

                const phone = phoneInputLogin.value.length > 0 ? phoneInputLogin.value.trim() : phoneInputRegister.value.trim();
                const otp = otpInput.value.trim();
                const nonce = document.getElementById('phone_auth_nonce').value;

                if (!otp) {
                    message_alert('error', 'لطفا کد چهار رقمی را وارد کنید.');
                    return;
                }

                verifyOtpBtn.disabled = true;
                verifyOtpBtn.textContent = 'در حال بررسی...';
                let formData = new URLSearchParams({
                    action: 'process_phone_auth',
                    phone: phone,
                    otp: otp,
                    name:nameInput.value,
                    phone_auth_nonce: nonce
                });

                fetch(phoneAuth.ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            message_alert('success', data.data.message);
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'otpForm',
                                'option': '3'
                            });
                            if (data.data.redirect) {
                                window.location.href = data.data.redirect;
                            }
                        } else {
                            message_alert('error', data.data.message);
                            verifyOtpBtn.disabled = false;
                            verifyOtpBtn.textContent = phoneAuth.verifyText;
                        }
                    })
                    .catch(error => {
                        message_alert('error', 'احراز هویت با خطا مواجه شد. مجدد تلاش کنید.');
                        verifyOtpBtn.disabled = false;
                        verifyOtpBtn.textContent = phoneAuth.verifyText;
                        console.error('Error:', error);
                    });
            });
        }

        if (otpResend) {
            otpResend.addEventListener('click', function (e) {
                e.preventDefault();
                const phone = phoneInputLogin.value.length > 0 ? phoneInputLogin.value.trim() : phoneInputRegister.value.trim();
                let formData = new URLSearchParams({
                    action: 'process_resend_otp',
                    phone: phone,
                });
                fetch(phoneAuth.ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {

                        if (data.success) {
                            message_alert('success', data.data.message);
                            if (data.data.debug_otp) {
                                console.log('DEBUG OTP: ' + data.data.debug_otp);
                            }

                            otpResend.style.display = 'none';
                            // Start OTP timer
                            startOtpTimer();
                        } else {
                            console.log(data)
                            message_alert('error', data.data.message);
                        }
                        // sendOtpBtnRegister.disabled = false;
                        // sendOtpBtnRegister.textContent = phoneAuth.resendText;
                    })
                    .catch(error => {
                        message_alert('error', 'ارسال کد انجام نشد لطفا مجدد تلاش کنید.');
                        sendOtpBtnRegister.disabled = false;
                        sendOtpBtnRegister.textContent = 'ارسال کد';
                        console.error('Error:', error);
                    });
            })
        }

        // Helper function to show messages
        function showAuthMessage(message, type) {
            authMessage.innerHTML = `<div class="${type}">${message}</div>`;
        }

        // OTP timer functions
        function startOtpTimer() {
            clearInterval(otpTimer);
            timeLeft = 120;
            updateOtpTimerDisplay();
            otpTimer = setInterval(function () {
                timeLeft--;
                updateOtpTimerDisplay();
                if (timeLeft <= 0) {
                    clearInterval(otpTimer);
                }
            }, 1000);
        }

        function updateOtpTimerDisplay() {
            const minutes = Math.floor(timeLeft / 60);
            const seconds = timeLeft % 60;
            otpTimerDisplay.textContent =
                (minutes < 10 ? '0' + minutes : minutes) + ':' +
                (seconds < 10 ? '0' + seconds : seconds);

            if (timeLeft <= 0) {
                otpResend.style.display = 'block';
            }
        }
    });
})();
